/**
 * Inicializa o plugin do editor Summernote
 */
window.initSummernote = function initSummernote(dialog = null) {
    const parent = dialog ? `#${dialog.id}` : 'body';

    const config = {
        lang: 'pt-BR',
        minHeight: 150,
        dialogsFade: true,
        codemirror: {
            theme: 'monokai'
        },
        toolbar: [
            ['style', ['bold', 'italic', 'underline', 'strikethrough', 'clear']],
            ['fontsize', ['fontsize']],
            ['font', ['superscript', 'subscript', 'height']],
            ['color', ['color']],
            ['para', ['ul', 'ol', 'paragraph']],
            ['insert', ['link', 'picture', 'video', 'table']],
            ['view', ['undo', 'fullscreen', 'codeview', 'help']],
        ],
        fontSizes: ['8', '10', '12', '14', '16', '18', '20', '24', '28', '32', '36', '48', '60', '72'],
        lineHeights: ['0.4', '0.5', '0.6', '0.8', '1.0', '1.2', '1.4', '1.5', '1.6', '1.8', '2.0', '3.0'],
        callbacks: {
            onInit: function () {
                // Configura o posicionamento do textarea para exibir as mensagens de validação do HTML
                if (this.hasAttribute('required')) {
                    this.style.display = 'block';
                    this.style.position = 'absolute';
                    this.style.opacity = 0;
                    this.style.top = '50%';
                    this.style.left = 0;
                    this.style.right = 0;
                    this.parentElement.style.position = 'relative';
                }
            }
        },
        popover: {
            image: [
                ['image', ['resizeFull', 'resizeHalf', 'resizeQuarter', 'resizeNone']],
                ['float', ['floatLeft', 'floatRight', 'floatNone']],
                ['remove', ['removeMedia', 'imageAttributes']]
            ],
            link: [
                ['link', ['linkDialogShow', 'unlink']]
            ],
            table: [
                ['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']],
                ['delete', ['deleteRow', 'deleteCol', 'deleteTable']],
            ],
            air: [
                ['color', ['color']],
                ['font', ['bold', 'underline', 'clear']],
                ['para', ['ul', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'picture']]
            ]
        },

        imageAttributes: {
            icon: '<i class="note-icon-magic"/>',
            removeEmpty: true,
            disableUpload: true
        },
    };

    $(`${parent} .summernote:not(.summenote-air-mode)`).summernote(config);
    $(`${parent} .summernote.summenote-air-mode`).summernote({ ...config, airMode: true });
}
